/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useContext, useEffect } from "react";
import { Box, Tooltip } from "@chakra-ui/react";
import { Button, H2 } from "pages/Pass-Form/stylePases";
import {
  GrDocumentWord,
  GrDocumentPdf,
  GrDocumentWindows,
  GrDocumentText,
} from "react-icons/gr";
import { IconGeneric } from "styled/Icons.styled";
import { MdDelete } from "react-icons/md";
import Swal from "sweetalert2";
import PassCrudContext from "context/PassCrudContext";
import environment from "constants/apiConst";
import { ButtonHeaderModule } from "styled/Buttons.styled";
import { RiUploadCloudFill } from "react-icons/ri";
import Vapor from "laravel-vapor";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";

export const AdjuntoOneAttac = ({
  set,
  file = [],
  data,
  handleAttachment,
  titulo = "Adjunto",
  contextRef = PassCrudContext,
  update = () => {},
  callBackDelete = () => {},
  btnView = true,
  updatedOnDelete= true,
}) => {
  const { deleteAttachment } = useContext(contextRef);
  const token = useSelector((state) => state.auth.dataUser.token);

  const downloadAttachment = (url) => {
    /* Open in new tab */
    window.open(url, "_blank");

  };

  const Upload = (activacion) => {
    document.getElementById(`${activacion}`).click();
  };

  const removeItemFromArr = async (arr, item, index, archivo, id) => {
    Swal.fire({
      title: `¿Estas seguro de eliminar el archivo "${item}"?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#1F7AC3",
      confirmButtonText: "Eliminar",
      customClass: {
        title: "class-text",
      },
    }).then((resultado) => {
      if (resultado.isConfirmed) {
        if (arr[index].name) {
          const resultado = arr.filter((e) => e.name !== item);
         if(updatedOnDelete) set(resultado);
         callBackDelete(index)
        } else {
          const resultado = arr.filter((e) => e.name_attachment !== item);
          if(updatedOnDelete) set(resultado);
         callBackDelete(index)
          const formData = new FormData();
          formData.append("attachment", archivo);

          if (titulo === "Otros") {
            deleteAttachment(
              environment.DELETE_OTHER_ATTACHMENT_CUSTOMS,
              formData,
              id
            );
          } else if (titulo === "Declaración de importación") {
            deleteAttachment(environment.DELETE_ATTACHMENT_CUSTOMS, id);
          }

          // deleteAttachment();
        }
      }
    });
  };

  async function uploadFile(file) {
    return Vapor.store(file, {
      baseURL: environment.VAPOR_BASE_URL,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  const vaporRes = async (file) => {
    const res = await uploadFile(file);
    return res;
  };

  useEffect(() => {
    if (update && file) {
      const res = vaporRes(file[0]);
      const fileData = file[0] || {};
      update(res, fileData?.name);
    }
  }, [file]);

  return (
    <>
      <Box className="mt-4 ms-2 p-2">
        <div className="row">
          <div className="col-6 mt-2">
            <h2 className="mb-3">{titulo}</h2>
          </div>
          {!data?.length && btnView === true && (
            <div className="col-6 mt-2">
              <Tooltip placement="top" hasArrow label="Agregar adjunto">
                <span>
                  <ButtonHeaderModule
                    onClick={() => Upload(titulo.replace(/\s+/g, ""))}
                    bgColor="#03C39A"
                  >
                    <IconGeneric color="#fff" as={RiUploadCloudFill} />
                  </ButtonHeaderModule>
                </span>
              </Tooltip>
            </div>
          )}
        </div>

        <input
          onChange={(e) => handleAttachment(e, titulo)}
          type="file"
          hidden
          value={data?.attachment || ""}
          id={titulo.replace(/\s+/g, "")}
          accept=".doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf,application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet (.XLSX)"
        />

        <br />
        {data
          ? data.map((items, index) => (
              <ul className="p-2" key={index}>
                <li>
                  {titulo === "Declaración de importación" ? (
                    <IconGeneric
                      className="m-1"
                      as={
                        items?.type
                          ? items?.type.includes("word")
                            ? GrDocumentWord
                            : items?.type.includes("pdf")
                            ? GrDocumentPdf
                            : items?.type.includes("excel")
                            ? GrDocumentWindows
                            : GrDocumentText
                          : items?.name_attachment.includes("word")
                          ? GrDocumentWord
                          : items?.name_attachment.includes("pdf")
                          ? GrDocumentPdf
                          : items?.name_attachment.includes("excel")
                          ? GrDocumentWindows
                          : items?.name_attachment.includes("xls")
                          ? GrDocumentWindows
                          : GrDocumentText
                      }
                    />
                  ) : (
                    <IconGeneric
                      className="m-1 text-danger"
                      as={
                        items.name_other_attachment
                          ? items.name_other_attachment.includes("word")
                            ? GrDocumentWord
                            : items.name_other_attachment.includes("pdf")
                            ? GrDocumentPdf
                            : items.name_other_attachment.includes("excel")
                            ? GrDocumentWindows
                            : items.name_other_attachment.includes("xls")
                            ? GrDocumentWindows
                            : GrDocumentText
                          : GrDocumentText
                      }
                    />
                  )}
                  {items?.name_attachment || items.name_other_attachment ? (
                    <Tooltip placement="top" hasArrow label="Descargar">
                          <NavLink
                            target="_blank"
                            to={items?.attachment_url}
                            className="ms-2"
                          >
                            <span
                              id="downloadFile"
                              type={Button}
                            >
                              {items?.name_attachment || items?.name_other_attachment}{" "}
                            </span>
                          </NavLink>
                    </Tooltip>
                  ) : (
                    <>{items?.name}</>
                  )}
                  <IconGeneric
                    onClick={() =>
                      removeItemFromArr(
                        data,
                        items?.name || items?.name_attachment,
                        index,
                        items?.attachment || items?.other_attachment,
                        items?.id
                      )
                    }
                    className="m-1 text-danger"
                    as={MdDelete}
                  />
                </li>
              </ul>
            ))
          : ""}
      </Box>
    </>
  );
};
